<template>
  <v-row>
    <v-col cols="12">
      <template v-if="character.resetSkills.skillPoints.physique > 0">
        You have {{ character.skills.skillPoints.physique }} points to invest in Physique skills.
        <br>
      </template>
      <template v-if="character.resetSkills.skillPoints.finesse > 0">
        You have {{ character.skills.skillPoints.finesse }} points to invest in Finesse skills.
        <br>
      </template>
      <template v-if="character.resetSkills.skillPoints.mind > 0">
        You have {{ character.skills.skillPoints.mind }} points to invest in Mind skills.
        <br>
      </template>
      <template v-if="character.resetSkills.skillPoints.spirit > 0">
        You have {{ character.skills.skillPoints.spirit }} points to invest in Spirit skills.
        <br>
      </template>
      <template v-if="character.resetSkills.skillPoints.specialty > 0">
        You have {{ character.skills.skillPoints.specialty }} points to invest in Specialty (Craft, Talent) skills.
        <br>
      </template>
      <template v-if="character.resetSkills.skillPoints.general > 0">
        You have {{ character.skills.skillPoints.general }} points to invest in skills of your choosing.
        <br>
      </template>
      <v-data-table
        :items="skillList"
        :headers="columns"
        hide-default-footer
        :items-per-page="skillList.length"
        sort-by="name"
        dark
        class="secondary"
        :key="tableKey">
        <template v-slot:item.stat="{ item }">
          <avatarStat :traitType="item.stat.toLowerCase()" />
        </template>
        <template v-slot:item.counter="{ item }">
          <template v-if="item.name === 'Adaptable'">
            <v-icon dark @click="decrementSkill(item)" :disabled="!character.traits.includes('Versatile')">mdi-minus</v-icon>
              {{ character.skills.values[item.name] ? character.skills.values[item.name] : 0 }} / {{ skillMax(item.stat.toLowerCase()) }}
            <v-icon dark @click="incrementSkill(item)" :disabled="!character.traits.includes('Versatile')">mdi-plus</v-icon>
          </template>
          <template v-else-if="!item.name.includes('()')">
            <v-icon dark @click="decrementSkill(item)">mdi-minus</v-icon>
              {{ character.skills.values[item.name] ? character.skills.values[item.name] : 0 }} / {{ skillMax(item.stat.toLowerCase()) }}
            <v-icon dark @click="incrementSkill(item)">mdi-plus</v-icon>
          </template>
          <template v-else>
            <v-btn width="100%" color="primary" @click="createSkill(item.name)">Add</v-btn>
          </template>
        </template>
        <template v-slot:header.counter="{}">
          <v-btn width="100%" color="accent" @click="resetSkills()">Reset</v-btn>
        </template>
      </v-data-table>
      <v-dialog v-model="showCreate" :max-width="240">
        <v-sheet color="primary" style="overflow: auto;" max-height="240" class="pa-2">
          <v-sheet color="secondary" class="white--text">
            <v-text-field v-model="newSkill.name" :label="newSkill.template" dark />
            <v-select v-if="newSkill.statOptions" v-model="newSkill.stat" :items="newSkill.statOptions" dark />
            <v-btn width="100%" color="accent" v-if="checkValid" @click="confirmCreate()">Create</v-btn>
          </v-sheet>
        </v-sheet>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';

export default {
  components: {
    avatarStat: () => import('../avatarStat')
  },
  props: {
    character: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showCreate: false,
      newSkill: { name: '' },
      skillList: [],
      skillSubsets:[
        {
          name: 'Craft(Alchemy)',
          stat: 'Mind'
        },
        {
          name: 'Craft(Artistry)',
          stat: 'Mind'
        },
        {
          name: 'Craft(Blacksmith)',
          stat: 'Mind'
        },
        {
          name: 'Craft(Woodworking)',
          stat: 'Mind'
        },
        {
          name: 'Knowledge(Arcana)',
          stat: 'Mind'
        },
        {
          name: 'Knowledge(History)',
          stat: 'Mind'
        },
        {
          name: 'Knowledge(Language)',
          stat: 'Mind'
        },
        {
          name: 'Knowledge(Religion)',
          stat: 'Mind'
        },
        {
          name: 'Knowledge(Research)',
          stat: 'Mind'
        }
      ],
      tableKey: 0,
      columns: [
        {
          text: 'Type',
          value: 'stat'
        },
        {
          text: 'Skill',
          value: 'name'
        },
        {
          text: 'Summary',
          value: 'description'
        },
        {
          value: 'counter',
          sortable: false
        }
      ]
    };
  },
  created() {
    this.skillList = this.contentItem('table|7-1').items.concat(this.skillSubsets).concat(this.character.skills.custom);
  },
  methods: {
    decrementSkill(skill) {
      if (this.character.skills.values[skill.name] && (!this.character.resetSkills.values[skill.name] || this.character.skills.values[skill.name] > this.character.resetSkills.values[skill.name])) {
        if (this.character.skills.values[skill.name] > 1) {
          this.character.skills.values[skill.name] -= 1;
        } else {
          delete this.character.skills.values[skill.name];
        }
        if (skill.stat.includes('-')) {
          const stats = skill.stat.toLowerCase().split('-');
          if (this.character.skills.skillPoints[stats[0]] < this.character.resetSkills.skillPoints[stats[0]]) {
            this.character.skills.skillPoints[stats[0]]++;
          } else if (this.character.skills.skillPoints[stats[1]] < this.character.resetSkills.skillPoints[stats[1]]) {
            this.character.skills.skillPoints[stats[1]]++;
          } else if (this.character.skills.skillPoints.general < this.character.resetSkills.skillPoints.general) {
            this.character.skills.skillPoints.general++;
          }
        } else if (skill.stat === 'Physique' && this.character.skills.skillPoints.physique < this.character.resetSkills.skillPoints.physique) {
          this.character.skills.skillPoints.physique++;
        } else if (skill.stat === 'Finesse' && this.character.skills.skillPoints.finesse < this.character.resetSkills.skillPoints.finesse) {
          this.character.skills.skillPoints.finesse++;
        } else if (skill.stat === 'Mind' && this.character.skills.skillPoints.mind < this.character.resetSkills.skillPoints.mind) {
          this.character.skills.skillPoints.mind++;
        } else if (skill.stat === 'Spirit' && this.character.skills.skillPoints.spirit < this.character.resetSkills.skillPoints.spirit) {
          this.character.skills.skillPoints.spirit++;
        } else if ((skill.name.includes('Craft') || skill.name.includes('Talent')) && this.character.skills.skillPoints.specialty < this.character.resetSkills.skillPoints.specialty) {
          this.character.skills.skillPoints.specialty++;
        } else if (this.character.skills.skillPoints.general < this.character.resetSkills.skillPoints.general) {
          this.character.skills.skillPoints.general++;
        }
        this.tableKey++;
      }
    },
    incrementSkill(skill) {
      let takeSkillPoint = false;
      let skillAction = {};
      if (!this.character.skills.values[skill.name]) {
        const newSkill = { [skill.name] : 1 };
        skillAction = () => { this.character.skills.values = Object.assign(this.character.skills.values, newSkill); };
        takeSkillPoint = true;
      } else {
        if (this.character.skills.values[skill.name] < this.skillMax(skill.stat)) {
          skillAction = () => { this.character.skills.values[skill.name]++; };
          takeSkillPoint = true;
        }
      }
      if (takeSkillPoint) {
        if (skill.stat.includes('-')) {
          const stats = skill.stat.toLowerCase().split('-');
          if (this.character.skills.skillPoints[stats[0]] > 0) {
            skillAction();
            this.character.skills.skillPoints[stats[0]]--;
          } else if (this.character.skills.skillPoints[stats[1]] > 0) {
            skillAction();
            this.character.skills.skillPoints[stats[1]]--;
          } else if (this.character.skills.skillPoints.general > 0) {
            skillAction();
            this.character.skills.skillPoints.general--;
          } 
        } else if ((skill.name.includes('Craft') || skill.name.includes('Talent')) && this.character.skills.skillPoints.specialty > 0) {
          skillAction();
          this.character.skills.skillPoints.specialty--;
        } else if (skill.stat === 'Physique' && this.character.skills.skillPoints.physique > 0) {
          skillAction();
          this.character.skills.skillPoints.physique--;
        } else if (skill.stat === 'Finesse' && this.character.skills.skillPoints.finesse > 0) {
          skillAction();
          this.character.skills.skillPoints.finesse--;
        } else if (skill.stat === 'Mind' && this.character.skills.skillPoints.mind > 0) {
          skillAction();
          this.character.skills.skillPoints.mind--;
        } else if (skill.stat === 'Spirit' && this.character.skills.skillPoints.spirit > 0) {
          skillAction();
          this.character.skills.skillPoints.spirit--;
        } else if (this.character.skills.skillPoints.general > 0) {
          skillAction();
          this.character.skills.skillPoints.general--;
        }
      }
      this.tableKey++;
    },
    skillMax(stat) {
      let returnVal = Math.ceil(this.character.level / 2);
      if (stat.includes('-')) {
        returnVal += this.character[this.statCheck(stat.toLowerCase())];
      } else {
        returnVal += this.character[stat.toLowerCase()];
      }
      const skillEmpowermentCheck = this.character.traits.filter(trait => trait.toLowerCase().includes('skill empowerment')).length;
      returnVal += skillEmpowermentCheck * 2;
      return returnVal;
    },
    statCheck(stat) {
      const stats = stat.split('-');
      if (this.character[stats[0]] > this.character[stats[1]]) {
        return stats[0];
      } else {
        return stats[1];
      }
    },
    resetSkills() {
      this.character.skills = _.cloneDeep(this.character.resetSkills);
      this.skillList = this.contentItem('table|7-1').items.concat(this.skillSubsets).concat(this.character.skills.custom);
      this.tableKey++;
    },
    createSkill(skillName) {
      switch(skillName) {
        case 'Craft()':
          this.newSkill = {
            name: '',
            stat: 'Mind',
            template: 'Craft'
          };
          break;
        case 'Knowledge()':
          this.newSkill = {
            name: '',
            stat: 'Mind',
            template: 'Knowledge'
          };
          break;
        case 'Talent()':
          this.newSkill = {
            name: '',
            stat: 'Physique',
            template: 'Talent',
            statOptions: ['Physique', 'Finesse', 'Mind', 'Spirit']
          };
          break;
      }
      this.showCreate = true;
    },
    confirmCreate() {
      const finalSkill = {
        name: this.newSkill.template + '(' + this.newSkill.name.trim() + ')',
        stat: this.newSkill.stat
      };
      this.character.skills.custom.push(finalSkill);
      this.skillList.push(finalSkill);
      this.showCreate = false;
    }
  },
  computed: {
    ...mapGetters('actsContent', ['contentItem']),
    checkValid() {
      const skillName = this.newSkill.template + '(' + this.newSkill.name.trim() + ')';
      if (!this.skillList.find(skill => skill.name.toLowerCase() === skillName.toLowerCase())) {
        return true;
      }
      return false;
    }
  }
};
</script>

<style></style>
